// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__bELt3","col":"styles_col__H2Yta","fulfillmentStatus":"styles_fulfillmentStatus__3vbyG","emailCol":"styles_emailCol__1DkXh"};